import { defineStore } from "pinia";

import { sendWsReconnect } from "@/composables/useEventBus";
import { RingBuffer } from "@/utils/RingBuffer";

interface WebsocketState {
  timestamp: number;
  state: string;
}

export const useConnectionStore = defineStore("connection", {
  state: () => ({
    netWs: true,
    netOnline: true,
    alm: true,
    lastConnect: 0,
    lastDisconnect: 0,
    reconnects: 0,
    wsStates: new RingBuffer<WebsocketState>(20),
    lastFrozen: 0,
    lastUnfrozen: 0,
  }),
  getters: {
    isConnected(state) {
      return state.netWs && state.netOnline;
    },
  },
  actions: {
    addWebsocketState(state: string) {
      this.wsStates.add({ timestamp: Date.now(), state });
    },
    setOffline() {
      this.lastDisconnect = Date.now();
      this.netOnline = false;
    },
    setOnline() {
      this.lastConnect = Date.now();
      this.netOnline = true;
    },
    freeze() {
      this.lastFrozen = Date.now();
    },
    unfreeze() {
      this.lastUnfrozen = Date.now();
    },
    disconnectWebsocket() {
      this.netWs = false;
    },
    reconnectWebsocket() {
      this.reconnects++;
      this.netWs = true;
      // Notify the board that the websocket has reconnected
      // We can't just watch for changes to netWs, because the disconnect event
      // isn't always processed (eg. when the computer goes to sleep)
      sendWsReconnect();
    },
  },
});

export function formatState(entry: WebsocketState) {
  return `${new Date(entry.timestamp).toISOString()}: ${entry.state}`;
}
